import React, { useEffect, useState, Suspense, lazy } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Navbar from './Components/Layout/Header/MainNabBar';
import './Components/Utility/Utility.css';
import './Pages/DevlopmentOrder/Bom/BomList.css';
import BomLibrary from './Pages/Library/BomLibrary/BomLibrary';
import BomLibraryGroup from './Pages/Library/BomLibrary/BomLibraryGroup/BomLibraryGroup';
import AddEditBomLibraryGroup from './Pages/Library/BomLibrary/BomLibraryGroup/AddEditBomLibraryGroup';
import BomTypeGroup from './Pages/Library/BomType/BomTypeGroup/BomTypeGroup';
import BomStateprovider from './Pages/DevlopmentOrder/Bom/BomProvider/index';
import POTemplateStateProvider from './Pages/Library/P.O.Template/P.O.TemplateContext/index';
import AddEditPOTemplates from './Pages/Library/P.O.Template/AddModalChanges/Index';
import DevlopmentOrderWrapper from './Pages/DevlopmentOrder/DevlopmentOrderWrapper';
import ReorderList from './Pages/DevlopmentOrder/ProductInformation/ProductListContainer/ReorderList';
import Utility from './Pages/Utility';
import MasterDesign from './Pages/MasterDesign';
import BombiixIcons from './Pages/BombiixIcons';
import BombiixIconsTsx from './Pages/BombiixIconsTsx';
import Supplier from './Pages/Supplier/Supplier';
import SuppliersDocuments from './Pages/Supplier/SupplierDocuments/SuppliersDocuments';
import SupplierTabLayout from './Pages/Supplier/SupplierTabLayout';
import Measurment from './Pages/DevlopmentOrder/Measurment/MarkerMeasurment';
import SupplierSuggestion from './Pages/SupplierSuggestion/SupplierSuggestion';
import SuggestionList from './Pages/SupplierSuggestion/SuggestionList';
import SupplierSuggestionDetail from './Pages/SupplierSuggestion/SuggestionDetail';
import DesignDetailAnnotation from './Pages/DevlopmentOrder/DesignDetail/DesignDetailAnnotation';
import SampleAnnotation from './Pages/DevlopmentOrder/SampleAnnotation/SampleAnnotation';
import SupplierImageAnnotation from './Pages/DevlopmentOrder/SupplierImageAnnotation/SupplierImageAnnotation';
import PomAnnotation from './Pages/Library/Pom/PomAnnotation';
import SystemMasters from './Pages/SystemMasters/SystemMasters';
import ColorLibraryGroup from './Pages/Library/ColorLibary/colourLibraryGroup/ColorLibraryGroup';
import TestingLibraryGroup from './Pages/Library/Testing/TestingGroups/TestingGroups';
import AddEditTestingGroup from './Pages/Library/Testing/TestingGroups/AddEditTestingGroup';
// import SampleDetails from "./Pages/DevlopmentOrder/Samples/SampleDetails/SampleDetails";
import SampleDetails from './Pages/DevlopmentOrder/ProductSamples/SampleDetails/SampleDetails';
import RangePlan from './Pages/RangePlan/RangePlan';
import RangePlanProductList from './Pages/RangePlan/ProductList/ProductListNew';
import PlanningActual from './Pages/PlanningActual/PlanningActual';
import PlanningActualProvider from './Pages/PlanningActual/Context/index';
import PlanningBottomUp from './Pages/PlanningBottomUp/PlanningBottomUp';
import PlanningBottomUpProvider from './Pages/PlanningBottomUp/Context/index';
import OprationalCPIndex from './Pages/OprationalCP/Index';
import AddEditOprationalCP from './Pages/OprationalCP/AddEditOprationalCP';
import DetailsOprationalCPPage from './Pages/OprationalCP/DetailsOprationalCPPage';
import TodoList from './Pages/Dashboard/TodoList/TodoList';
import PurchaseOrderDetails from './Pages/DevlopmentOrder/PurchaseOrder/PurchaseOrderDetails';
import PurchaseOrderStateProvider from './Pages/DevlopmentOrder/PurchaseOrder/PurchaseOrderContext';
import PurchaseOrderHistory from './Pages/DevlopmentOrder/PurchaseOrder/PurchaseOrderHistory';
import PurchaseOrderLog from './Pages/DevlopmentOrder/PurchaseOrder/PurchaseOrderLog';
import PlaceholderManagementStateProvider from './Pages/PlaceholderManagementTSX/context/PlaceholderProvider';
import CustomColumnContextProvider from './Pages/RangePlan/CustomSections/CustomColumnContextProvider';
import RangePlanProductListingProvider from './Pages/RangePlan/ProductList/RangePlanProductListingProvider';
import RangePlanCustomSection from './Pages/RangePlan/CustomSections';
import RangePlanColumnsCustomSection from './Pages/RangePlan/CustomSections/AddColumns';
import ProductHistory from './Pages/ProductHistory';
import UserManagement from './Pages/UserSetting/UsersManagement/UserManagement';
import UsersLibrary from './Pages/UserSetting/UsersLibrary/usersLibrary';
import UserGroups from './Pages/UserSetting/UserGroups';
import Channel from './Pages/PlanningBottomUp/Channel/Channel';
import { useComponent } from './Pages/UserSetting/UsersLibrary/UserRights';
import SubmitDownlod from './Pages/DevlopmentOrder/SubmitDownload/SubmitDownload';
import DownloadLog from './Pages/DevlopmentOrder/SubmitDownload/DownloadLog';
import SubmitDownlodLog from './Pages/DevlopmentOrder/SubmitDownload/SubmitDownloadLog';
import ProductCPIndex from './Pages/ProductCP/index';
import ProductCPLogs from './Pages/ProductCP/ProductCPLogs';
import AddEditProductCP from './Pages/ProductCP/AddEditProductCP';
import DetailProductCP from './Pages/ProductCP/DetailProductCP';

import SubmitDownloadHistory from './Pages/DevlopmentOrder/ProductInformation/SubmitPopup/SubmitDownloadHistory';
import CareLabel from './Pages/Library/CareLabel/List';
import CareLabelGroup from './Pages/Library/CareLabel/group/List';
import CareLabelGroupAddEdit from './Pages/Library/CareLabel/group/AddEdit';
import CareLabelProvider from './Pages/Library/CareLabel/context/index';
import SocketProvider from './socket';
import ComponentOrderStateProvider from './Pages/ComponentOrder/ComponentProvider';
import ComponentOrderList from './Pages/ComponentOrder/index';
import AddPOTemplateProvider from './Pages/ComponentOrder/AddEditPOTemplate/AddPOTemplateProvider';
import AddEditPOTemplate from './Pages/ComponentOrder/AddEditPOTemplate';
import SubmitDownloadLogPublic from './Pages/DevlopmentOrder/SubmitDownload/SubmitDownloadLogPublic';
import PurchaseOrderDetail from './Pages/ComponentOrder/PurchaseOrderList/PurchaseOrderDetail';
import POrderDetailStateProvider from './Pages/ComponentOrder/PurchaseOrderList/PurchaseOrderDetail/PODetailProvider';
import CustomModuleStateProvider from './Pages/Library/CustomModule/Context/index';
import CustomModuleAddEdit from './Pages/Library/CustomModule/Library/AddEdit';
import CustomModuleGroupList from './Pages/Library/CustomModule/Group/List';
import CustomModuleGroupAddEdit from './Pages/Library/CustomModule/Group/AddEdit';
import PreviewModal from './Pages/DevlopmentOrder/PurchaseOrder/PurchaseOrderHistory/PreviewModal';
import ProductInformation from './Pages/DevlopmentOrder/ProductInformation';
import CreateProduct from './Pages/DevlopmentOrder/ProductInformation/CreateProduct';
import ProductTableView from './Pages/DevlopmentOrder/ProductInformation/ProductTableView';
import ProductInfoStateProvider from './Pages/DevlopmentOrder/ProductInformation/Provider';
import BulkEdit from './Pages/DevlopmentOrder/ProductInformation/BulkEdit';
import BulkEditProvider from './Pages/DevlopmentOrder/ProductInformation/BulkEdit/BulkEditProvider';
import AddGradingGroupProvider from './Pages/Library/Pom/GradingGroup/GradingGroupProvider';
import GradingGroup from './Pages/Library/Pom/GradingGroup';
import CustomModuleProductStateProvider from './Pages/DevlopmentOrder/CustomModule/Context/index';
import GradingListing from './Pages/Library/Pom/GradingGroupListing/index';
import GradingGroupProvider from './Pages/Library/Pom/GradingGroupListing/GradingListionProvider';
import Login from './Pages/Auth/Login';
import SsoComplete from './Pages/Auth/SsoComplete';
import SsoSettings from './Pages/Settings/SsoSettings';
import SetNewPassword from './Pages/Settings/SetNewPassword';
import ResetPassword from './Pages/ResetPassword/ResetPassword';
import ForgotPW from './Pages/forgotPassword/ForgotPassword';
import { TabsToRightKeys, RightsAccess } from './Components/helper';
import AnswerSecurityQuestions from './Pages/Questions/AnswerSecurityQuestions';
import Setup2FA from './Pages/Auth/MultiFactor/Setup2FA';
import AccountDetails from './Pages/UserSetting/AccountDetails';
import VerificationCode from './Pages/Auth/VerificationCode';
import Factories from './Pages/UserSetting/Factories/Factories';
import SupplierSignup from './Pages/SupplierSignup/SupplierSignup';
import NonSupplierFactory from './Pages/NonSupplierFactory/NonSupplierFactory';
import SpecTemplateAddEdit from './Pages/Library/SpecTemplate/AddEditSpecTemplate';
import * as action from './Pages/UserSetting/store/User.action';
import SpecContextProvider from './Pages/Library/SpecTemplate/SpecContextProvider';
import MultiSubmitDownloadLogs from './Pages/DevlopmentOrder/SubmitDownload/MultiSubmitDownloadLogs';
import PomGroup from './Pages/Library/Pom/POMGroup/AddEditComponent/pomGroup';
import PomGroupProvider from './Pages/Library/Pom/POMGroup/AddEditComponent/PomGroupContext';
import PomList from './Pages/Library/Pom/POMGroup/PomList';
import PomGroupContextProvider from './Pages/Library/Pom/POMGroup/PomGroupListContext';
import ProductIdentifierContext from './Pages/DevlopmentOrder/ProductIdentifier/ProductIdentifierContext';

import SupplierTemplateProvider from './Pages/Supplier/SupplierTemplate/context/index';
import MultiDownloadLogs from './Pages/DevlopmentOrder/SubmitDownload/MultiDownloadLogs';
import AddEditDamFolderGroup from './Pages/Library/DamFolder/DamFolderGroup/AddEditDamFolderGroup';
import DAMModuleStateProvider from './Pages/DAM/Provider';
import DAM from './Pages/DAM';
import DAMAddEditModuleStateProvider from './Pages/DAM/AddEditDam/Provider';
import AddEditDAM from './Pages/DAM/AddEditDam';
import DamFolderGroup from './Pages/Library/DamFolder';
import ProgressbarUploader from './Components/ProgressbarUploader/ProgressbarUploader';
import DamFolderModuleStateProvider from './Pages/Library/DamFolder/Provider';
import DamHistory from './Pages/DAM/DamHistory';
import DamProductFileModuleStateProvider from './Pages/DevlopmentOrder/Dam/DamFiles/Provider';
import DamProductFolderModuleStateProvider from './Pages/DevlopmentOrder/Dam/DamFolder/Provider';
import DamFolder from './Pages/DevlopmentOrder/Dam/DamFolder';
import TabDetailsLandingPage from './Pages/Library/UserInstructionLibrary/TabDetailsLandingPage';
import DPPAddEdit from './Pages/Library/DPP/Library/AddEdit';
import DPPStateProvider from './Pages/Library/DPP/Context/index';
import EditSupplierToDo from './Pages/Dashboard/TodoList/SupplierTodoList/EditSupplierToDo';
import CareUserContextProvider from './Pages/Library/UserInstructionLibrary/provider/careUserContext';
import DPPProductModuleStateProvider from './Pages/DevlopmentOrder/DPPModule/Context/index';
import CareUserGroupListing from './Pages/Library/UserInstructionLibrary/CareUserGroupListing';
import AddEditCareUserGroup from './Pages/Library/UserInstructionLibrary/AddEditCareUserGroup';
import SuggestionProvider from './Pages/SupplierSuggestion/Provider/SuggestionProvider';
import RangePlanLogs from './Pages/RangePlan/ProductList/RangePlanLogs';
import ManualDocStateProvider from './Pages/ManualDocument/Provider/index';
import Document from './Pages/ManualDocument/document';
import AccountConfirmation from './Pages/Auth/Signup/AccountConfirmation';
import CPDetailStateProvider from './Pages/ProductCP/contextProvider/cpDetailProvider';
import ProductCostingTsxDetailPage from './Pages/DevlopmentOrder/ProductCostingTSX';
import ProductCostingTsxStateProvider from './Pages/DevlopmentOrder/ProductCostingTSX/ProductCostingContext';
import Loader from './Components/Utility/Loader/Loader';
import { BOM_V2_ENABLED, BOM_V2_ROUTES, PRODUCT_BOM_V2_ROUTES } from './constants/bom-v2.constants';
import PurchaseOrderTemplateBuilder from './Pages/Library/PurchaseOrderTemplate/AddEditTemplate/PurchaseOrderTemplateBuilder';
import { POTemplateDndProvider } from './Pages/Library/PurchaseOrderTemplate/AddEditTemplate/contextProvider/POTemplateDndContext';
import CreatePO from './Pages/Dashboard/TodoList/ProductPurchaseOrderTodo/CreatePO/index';
import AblyWrapper from './Pages/Ably/AblyWrapper';
import AddEditCardPage from './Pages/PlaceholderManagementTSX/AddEditCardPage';
import CardListPage from './Pages/PlaceholderManagementTSX/CardListPage';

import AddEditColourWayGroupNew from './Pages/Library/ColorLibary/colourLibraryGroup/AddEditColourWayGroupNew';
import MultiSubmit from './Pages/DevlopmentOrder/ProductInformation/MultiSubmit';
import CostingTemplateProviderTsx from './Pages/Library/CostingTemplateTSX/CostingColumns/contextProvider';
import { useProductLandingPath } from './Components/CustomHooks/useProductLandingPath';

const SupplierTemplate = lazy(() => import('./Pages/Supplier/SupplierTemplate/SupplierTemplateList'));
const SupplierTemplateAddEdit = lazy(() => import('./Pages/Supplier/SupplierTemplate/AddEdit'));
const AddEditSupplier = lazy(() => import('./Pages/Supplier/AddEditSupplier'));
const AddEditComponentSupplier = lazy(() => import('./Pages/Supplier/SupplierComponent/AddEditComponenetSupplier'));
const ColorLibrary = lazy(() => import('./Pages/Library/ColorLibary/ColorLibrary'));
const BomType = lazy(() => import('./Pages/Library/BomType/BomType'));
const BomV2Routes = lazy(() => import('./Pages/Library/BomLibraryV2/BomV2Routes'));
const ProductBomV2Routes = lazy(() => import('./Pages/DevlopmentOrder/ProductBomV2/ProductBomV2Routes'));
const Pom = lazy(() => import('./Pages/Library/Pom/Pom'));
const SpecTemplateList = lazy(() => import('./Pages/Library/SpecTemplate/List'));
const POTemplate = lazy(() => import('./Pages/Library/P.O.Template/index'));
const PurchaseOrderTemplateRoutes = lazy(() => import('./Pages/Library/PurchaseOrderTemplate/POTemplateLanding'));
const Testing = lazy(() => import('./Pages/Library/Testing/Testing'));
const FreightDutyTariffPage = lazy(() => import('./Pages/Library/FreightAndDuty/FreightDutyTariffPage'));
const DPPList = lazy(() => import('./Pages/Library/DPP/Library/List')); // Make sure to import DPP component
const RetailIdentifierList = lazy(() => import('./Pages/Library/RetailIdentifier/Library/List'));
const RetailIdentifierAddEdit = lazy(() => import('./Pages/Library/RetailIdentifier/Batch/AddEditBatch'));
const UserInstructionType = lazy(() => import('./Pages/Library/UserInstructionLibrary/UserInstructions'));
const CustomModuleList = lazy(() => import('./Pages/Library/CustomModule/Library/List'));
const ProductIdentifierTSX = lazy(() => import('./Pages/DevlopmentOrder/ProductIdentifierTSX/ProductIdentifierPage'));
const PIMTemplatesPage = lazy(() => import('./Pages/PIM/PIMTemplatesPage'));
const PIMProductTablePage = lazy(() => import('./Pages/PIM/PIMProductTablePage/PIMProductTablePage'));
const PIMDownloadLogPage = lazy(() => import('./Pages/PIM/PIMDownloadLogPage/PIMDownloadLogPage'));
const PIMProductDetailPage = lazy(() => import('./Pages/PIM/PIMProductDetailPage/PIMProductDetailPage'));
const PIMCardDetailPage = lazy(() => import('./Pages/PIM/PIMCardDetailPage/PIMCardDetailPage'));
const PIMHistoryPage = lazy(() => import('./Pages/PIM/HistoryPage'));
const DevlopmentOrderWrapperLazy = lazy(() => import('./Pages/DevlopmentOrder/DevlopmentOrderWrapper'));
const DesignDetailWrapper = lazy(() => import('./Pages/DevlopmentOrder/DesignDetail/DesignDetailWrapper'));
const TestingWrapper = lazy(() => import('./Pages/DevlopmentOrder/Testing/TestingWrapper'));
// const Samples = lazy(() => import("./Pages/DevlopmentOrder/Samples/Samples"));
const Samples = React.lazy(() => import('./Pages/DevlopmentOrder/ProductSamples/Samples'));
const CustomModuleProduct = lazy(() => import('./Pages/DevlopmentOrder/CustomModule/AddEdit'));
const DPPProduct = lazy(() => import('./Pages/DevlopmentOrder/DPPModule/DPPProduct'));
const PurchaseOrder = lazy(() => import('./Pages/DevlopmentOrder/PurchaseOrder'));
const NewPurchaseOrder = lazy(() => import('./Pages/DevlopmentOrder/ProductPurchaseOrder'));
const CreateEditPO = lazy(() => import('./Pages/DevlopmentOrder/ProductPurchaseOrder/CreateEditPO'));
const ProductPurchaseOrderRedirect = lazy(() => import('./Pages/DevlopmentOrder/ProductPurchaseOrder/ProductPurchaseOrderRedirect'));
const PurchaseOrderDocuments = lazy(() => import('./Pages/DevlopmentOrder/ProductPurchaseOrder/PurchaseOrderDocuments'));
const LogHistoryPage = lazy(() => import('./Pages/DevlopmentOrder/ProductPurchaseOrder/LogHistoryPage'));
const DamProductLazy = lazy(() => import('./Pages/DevlopmentOrder/Dam/index'));
const ProductCostingTsx = lazy(() => import('./Pages/DevlopmentOrder/ProductCostingTSX/productCostingListPage'));
const RangePlanCardView = lazy(() => import('./Pages/RangePlan/ProductList/RangeplanCardView/RangePlanCardView'));
const AddEditRangePlan = lazy(() => import('./Pages/RangePlan/ProductList/RangeplanCardView/AddEditRangePlan'));
const CostingListTsx = lazy(() => import('./Pages/Library/CostingTemplateTSX'));
const CostingColumnsTsx = lazy(() => import('./Pages/Library/CostingTemplateTSX/CostingColumns'));
const AssetLibrary = lazy(() => import('./Pages/AssetLibrary/AssetLibrary'));

export function PrivateRoutes({ role }) {
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const history = useHistory();
  const { getAllModulesAccessRights, getAllSectionAccessRights, CheckActionPermission, CheckModulePermission } = useComponent();
  if (localStorage.getItem('redirectToPO')) {
    localStorage.removeItem('redirectToPO');
  }
  if (localStorage.getItem('redirectionToPO')) {
    const poRedirect = localStorage.getItem('redirectionToPO');
    localStorage.removeItem('redirectionToPO');
    window.location.href = poRedirect;
  }

  const {
    suggestionRight,
    productCostingRight,
    purchaseOrderRight,
    placeholderRight,
    rangePlanRight,
    PIMRight,
    planningBottomUpRight,
    planningTopsDownRight,
    componentOrderRight,
    frieghtRight,
    productCriticalPathRight,
    reportsRight,
    checkRightWithKey,
    operationalCriticalPathRight,
    customModuleRight,
    DAMRight,
    DPPRight,
    TestingRight,
    manualDocsRight,
  } = RightsAccess();

  const {
    Users: { logInRights, moduleAccess, sectionAccess },
    UserDetails: { isSupplierLoggedIn, isCompanyAdminLoggedIn },
  } = devOrderReducer;

  // restrict custom module add edit route based on user access
  const CustomAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'customModule', 'addEdit');
  const SpecAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'spec', 'addEdit');
  const pomAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'pomGrading', 'addEdit');
  const PimAddEditAccess = CheckActionPermission(logInRights, 'pim', 'all', 'addEdit');
  const supplierAddEditAccess = CheckActionPermission(logInRights, 'supplierOverview', 'all', 'addEdit');
  const DamAddEditAccess = CheckActionPermission(logInRights, 'dam', 'all', 'addEdit');
  const damProAddEditAccess = CheckActionPermission(logInRights, 'products', 'DAM', 'addEdit');
  const dppAddEditAccess = CheckActionPermission(logInRights, 'dpp', 'all', 'addEdit');
  const retailIdentifierAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'retailIdentifier', 'addEdit');

  const [spin, setSpin] = useState(false);
  const [state, setState] = useState({
    mastersAccess: true,
    librariesAccess: true,
    productsAccess: true,
    rangePlanAccess: true,
    criticalPathAccess: true,
    planningAccess: true,
    placeholderAccess: true,
    supplierOverviewAccess: true,
    pimAccess: true,
    damAccess: true,
    dppAccess: true,
    manualsAccess: true,
  });
  const {
    mastersAccess,
    librariesAccess,
    productsAccess,
    rangePlanAccess,
    criticalPathAccess,
    planningAccess,
    placeholderAccess,
    supplierOverviewAccess,
    pimAccess,
    damAccess,
    dppAccess,
    manualsAccess,
  } = state;

  const dispatch = useDispatch();
  const [supplierPermission, setSupplierPermission] = useState(null);
  const getSupplierPermission = async () => {
    const supplierData = await dispatch(action.fetchSupplierPermissionService());
    setSupplierPermission(supplierData?.companies[0]?.canSuggest);
  };

  useEffect(() => {
    if (!isCompanyAdminLoggedIn) {
      getAllModulesAccessRights(logInRights);
      getAllSectionAccessRights(logInRights);
    }

    if (isSupplierLoggedIn) {
      getSupplierPermission();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logInRights]);

  const obj = {
    'sample-requests': 'samples',
    costing: 'costing',
    'purchase-order': 'purchaseOrder',
    'product-purchase-order-todo': 'purchaseOrder',
    testing: 'testing',
  };

  const modalCheck = (name) => {
    if (name === 'suggestion') {
      return moduleAccess?.supplierOverviewAccess === undefined ? true : moduleAccess.supplierOverviewAccess;
    }
    return CheckModulePermission(logInRights, 'products', obj[name], isCompanyAdminLoggedIn);
  };

  const checkModalAccess = (name) => {
    return ['progress-indicator', 'submit-download', 'my-todo'].includes(name) ? true : modalCheck(name);
  };

  useEffect(() => {
    if (!isEmpty(moduleAccess)) {
      setState((prev) => ({
        ...prev,
        ...moduleAccess,
      }));
      if (!isEmpty(sectionAccess)) {
        setSpin(true);
      }
    }
  }, [moduleAccess, sectionAccess]);

  const { t, i18n } = useTranslation('common');
  /**
   * Resolves the landing screen for a user who cannot stay on the requested route.
   * Walks the module-rights ladder from most to least privileged and stops at the
   * first screen the user may open, so each branch must exclude the ones above it.
   */
  const redirectToDashboard = () => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    const poRedirect = localStorage.getItem('redirectionToPO');
    if (user?.role === 'User') {
      if (reportsRight && moduleAccess?.productsAccess) {
        history.push('/todo-list/my-todo');
      } else if (moduleAccess?.productsAccess) {
        history.push('/development-order-overview');
      } else if (moduleAccess?.componentOrderAccess) {
        history.push('/component-order/purchase-order');
      } else if (moduleAccess?.librariesAccess) {
        history.push('/libraries/colour-library');
      } else if (moduleAccess?.supplierOverviewAccess) {
        history.push('/suppliers');
      } else if (moduleAccess?.manualsAccess) {
        history.push('/documents');
      } else if (moduleAccess?.mastersAccess) {
        history.push('/masters');
      } else {
        history.push('/settings/account-details');
      }
    } else if (productsAccess) {
      if (!poRedirect) window.location.assign(`${window.location.origin}/development-order-overview`);
    } else {
      window.location.assign(`${window.location.origin}/todo-list/my-todo`);
    }
  };
  const redirectFunction = () => {
    if (!productsAccess || role === 'Supplier' || role === 'SupplierUser') {
      // re varify the type of user
      redirectToDashboard();
      return false;
    }
    return true;
  };

  // if company has no rights then will redirect to dashboard
  const redirectOnNoRight = (right) => {
    if (!right) {
      redirectToDashboard();
    }
  };

  const redirectFromSubmitLog = () => {
    if (!productsAccess || role === 'SupplierUser') {
      redirectToDashboard();
    }
    return true;
  };

  const forAddEditBom = () => {
    if (!librariesAccess || role === 'Supplier') {
      redirectToDashboard();
    }
    return true;
  };

  const forRangeplanUrlRedirect = () => {
    if (!rangePlanAccess) {
      redirectToDashboard();
    }
    return true;
  };
  const forPlanningAccessRedirect = (val) => {
    if (spin) {
      const prodObj = sectionAccess?.planning;
      const obj1 = !isEmpty(prodObj) && prodObj[val];
      if (!planningAccess || obj1 === false || isSupplierLoggedIn) {
        redirectToDashboard();
      }
    }
  };
  const forPlaceHolderManagementRedirect = () => {
    if (!placeholderAccess || isSupplierLoggedIn) {
      redirectToDashboard();
    }
  };
  const productAccessRedirect = (val) => {
    if (spin) {
      const prodObj = sectionAccess?.products;
      const obj1 = !isEmpty(prodObj) && prodObj[val];
      if (!productsAccess || obj1 === false) {
        redirectToDashboard();
      }
    }
  };

  const forSupplierOverviewAccess = () => {
    if (!supplierOverviewAccess) {
      redirectToDashboard();
    }
    return true;
  };

  const forPIMAccess = () => {
    if (!pimAccess || isSupplierLoggedIn) {
      redirectToDashboard();
    }
    return true;
  };

  const forSpecAccess = () => {
    if (!sectionAccess?.libraries?.specAccess) {
      redirectToDashboard();
    }
  };

  const pomGradingAccess = () => {
    if (sectionAccess?.libraries?.pomGradingAccess !== undefined && !sectionAccess?.libraries?.pomGradingAccess) {
      redirectToDashboard();
    }
    return true;
  };

  const forCriticalPathRedirect = (val) => {
    if (spin) {
      const prodObj = sectionAccess?.criticalPath;
      const obj1 = !isEmpty(prodObj) && prodObj[val];
      if (!criticalPathAccess || obj1 === false || (isSupplierLoggedIn && val === 'operationalAccess')) {
        redirectToDashboard();
      }
    }
    return true;
  };

  const libraryAccessRedirect = (val) => {
    if (spin) {
      const prodObj = sectionAccess?.libraries;
      const hasAccess = _.chain(prodObj)
        .omit('tradeRefAccess') // Exclude 'tradeRefAccess'
        .values()
        .some((value) => value)
        .value();
      if (!hasAccess) {
        redirectToDashboard();
      }
    }
    return true;
  };

  const checkUserAccessPermissionRoutes = (moduleAction) => {
    if (!moduleAction) {
      redirectToDashboard();
    }
    return true;
  };

  const forDAMAccess = () => {
    if (!damAccess) {
      redirectToDashboard();
    }
    return true;
  };

  const forDPPAccess = () => {
    if (!dppAccess) {
      redirectToDashboard();
    }
    return true;
  };

  const forManualAccess = () => {
    if (!manualsAccess) {
      redirectToDashboard();
    }
    return true;
  };

  const libraryModuleAccessRedirect = (val) => {
    libraryAccessRedirect(val);
    if (spin && !isCompanyAdminLoggedIn && sectionAccess?.libraries?.[val] === false) {
      redirectToDashboard();
    }
    return true;
  };

  const productLandingPath = useProductLandingPath();

  /**
   * Without the Product Identifier right the user still owns the product, so they move on to the
   * next product page they may open (or the product list) instead of being sent to the dashboard.
   * @param {string} devOrderId - Product being opened.
   * @returns {boolean} Always true, so the route renders.
   */
  const productIdentifierAccessRedirect = (devOrderId) => {
    if (spin && productsAccess && !isCompanyAdminLoggedIn && sectionAccess?.products?.productIdentifierAccess === false) {
      history.replace(productLandingPath(devOrderId));
      return true;
    }
    productAccessRedirect('productIdentifierAccess');
    return true;
  };

  return (
    <>
      <SocketProvider>
        <Navbar t={t} i18n={i18n} />
      </SocketProvider>
      <Switch>
        <Route
          exact
          path="/purchase-order"
          render={(props) => {
            return (
              <PurchaseOrderStateProvider isPublicPoPage>
                <PreviewModal onOpen={false} toggle={false} isPublicPoPage {...props} />
              </PurchaseOrderStateProvider>
            );
          }}
        />

        <Route
          exact
          path="/development-order-overview"
          render={(props) => {
            productAccessRedirect('productAccess');
            return (
              <ProductInfoStateProvider>
                <AblyWrapper>
                  <ProductInformation {...props} />
                </AblyWrapper>
              </ProductInfoStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/development-order-overview/table-view"
          render={(props) => {
            productAccessRedirect('productAccess');
            return (
              <ProductInfoStateProvider>
                <AblyWrapper>
                  <ProductTableView {...props} />
                </AblyWrapper>
              </ProductInfoStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/development-order-overview/multi-submit"
          render={(props) => {
            return <MultiSubmit {...props} />;
          }}
        />
        <Route
          exact
          path="/component-order/po-template/create-po-template/:id"
          render={(props) => {
            return (
              <AddPOTemplateProvider>
                <AddEditPOTemplate {...props} />
              </AddPOTemplateProvider>
            );
          }}
        />
        <Route
          exact
          path="/suppliers/add"
          render={(props) => {
            return (
              <Suspense fallback={<Loader />}>
                <AddEditSupplier {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/suppliers/edit/:id"
          render={(props) => {
            return (
              <Suspense fallback={<Loader />}>
                <AddEditSupplier {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/factories/add"
          render={(props) => {
            return (
              <Suspense fallback={<Loader />}>
                <AddEditComponentSupplier {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/factories/edit/:id"
          render={(props) => {
            return (
              <Suspense fallback={<Loader />}>
                <AddEditComponentSupplier {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/component-order/po-template/create-po-template"
          render={(props) => {
            return (
              <AddPOTemplateProvider>
                <AddEditPOTemplate {...props} />
              </AddPOTemplateProvider>
            );
          }}
        />
        <Route
          exact
          path="/component-order/purchase-order/:id"
          render={(props) => {
            return (
              <POrderDetailStateProvider>
                <PurchaseOrderDetail {...props} />
              </POrderDetailStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/sub-supplier/purchase-order/:supplierType/:id/:supplierType"
          render={(props) => {
            return (
              <POrderDetailStateProvider>
                <PurchaseOrderDetail {...props} />
              </POrderDetailStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/sub-supplier/purchase-order/:supplierType"
          render={(props) => {
            return (
              <ComponentOrderStateProvider>
                <AddPOTemplateProvider>
                  <ComponentOrderList {...props} />
                </AddPOTemplateProvider>
              </ComponentOrderStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/component-order/:templateType"
          render={(props) => {
            redirectOnNoRight(componentOrderRight);
            return isSupplierLoggedIn ? (
              redirectToDashboard()
            ) : (
              <ComponentOrderStateProvider>
                <AddPOTemplateProvider>
                  <ComponentOrderList {...props} />
                </AddPOTemplateProvider>
              </ComponentOrderStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/development-order-overview/create"
          render={(props) => {
            productAccessRedirect('productAccess');
            return (
              <ProductInfoStateProvider>
                <AblyWrapper>
                  <CreateProduct {...props} />
                </AblyWrapper>
              </ProductInfoStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/development-order-overview/edit/:devOrderId"
          render={(props) => {
            productAccessRedirect('productAccess');
            return (
              <ProductInfoStateProvider>
                <AblyWrapper>
                  <CreateProduct {...props} />
                </AblyWrapper>
              </ProductInfoStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/:devOrderId/reorders"
          render={(props) => {
            return (
              <ProductInfoStateProvider>
                <ReorderList {...props} />
              </ProductInfoStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/modules-bulk-edit"
          render={(props) => {
            return (
              <BulkEditProvider>
                <BulkEdit {...props} />
              </BulkEditProvider>
            );
          }}
        />
        <Route
          exact
          path="/masters"
          render={(props) => {
            if (!mastersAccess || role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            return <SystemMasters {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/testing-group/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              // redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('testingAccess');
            redirectOnNoRight(TestingRight);
            return <AddEditTestingGroup {...props} />; // need to change once Data is set
          }}
        />
        <Route
          exact
          path="/libraries/testing-group/edit/:id"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('testingAccess');
            redirectOnNoRight(TestingRight);
            return <AddEditTestingGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/colour-library"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('coloursAccess');
            return (
              <Suspense fallback={<Loader />}>
                <ColorLibrary {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/colour-groups"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('coloursAccess');
            return <ColorLibraryGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/colour-group/add"
          render={(props) => {
            redirectFunction();
            libraryAccessRedirect('coloursAccess');
            return <AddEditColourWayGroupNew {...props} />;
          }}
        />

        <Route
          exact
          path="/libraries/colour-group/edit/:id"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('coloursAccess');
            return <AddEditColourWayGroupNew {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/point-of-measures"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('pomGradingAccess');
            return (
              <Suspense fallback={<Loader />}>
                <Pom {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/pom-annotation"
          render={(props) => {
            libraryAccessRedirect('pomGradingAccess');
            return <PomAnnotation {...props} redirectToDashboard={redirectToDashboard} />;
          }}
        />
        <Route
          exact
          path="/libraries/gradings/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('pomGradingAccess');
            return (
              <AddGradingGroupProvider>
                <GradingGroup {...props} />
              </AddGradingGroupProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/gradings/edit/:id"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('pomGradingAccess');
            return (
              <AddGradingGroupProvider>
                <GradingGroup {...props} />
              </AddGradingGroupProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/gradings"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('pomGradingAccess');
            return (
              <GradingGroupProvider>
                <GradingListing {...props} />
              </GradingGroupProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/po-template"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('poTemplateAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <POTemplateStateProvider>
                  <POTemplate {...props} />
                </POTemplateStateProvider>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/purchase-order-template"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('poTemplateAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <PurchaseOrderTemplateRoutes {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/purchase-order-template/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('poTemplateAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <POTemplateDndProvider>
                <PurchaseOrderTemplateBuilder {...props} />
              </POTemplateDndProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/purchase-order-template/edit/:id"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('poTemplateAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <POTemplateDndProvider>
                <PurchaseOrderTemplateBuilder {...props} />
              </POTemplateDndProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/po-template/create-po-template/:id"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('poTemplateAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <POTemplateStateProvider>
                <AddEditPOTemplates {...props} />
              </POTemplateStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/po-template/create-po-template"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('poTemplateAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <POTemplateStateProvider>
                <AddEditPOTemplates {...props} />
              </POTemplateStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/testing"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('testingAccess');
            redirectOnNoRight(TestingRight);
            return (
              <Suspense fallback={<Loader />}>
                <Testing {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/testing-group"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              // re varify the type of user
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('testingAccess');
            redirectOnNoRight(TestingRight);
            return <TestingLibraryGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/bom-library/:id"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('bomAccess');
            return (
              <BomStateprovider>
                <BomLibrary {...props} />{' '}
              </BomStateprovider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/bom-type"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('bomAccess');
            return (
              <Suspense fallback={<Loader />}>
                <BomType {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/bom-library-group/:id"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('bomAccess');
            return <BomLibraryGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/bom-library-group/add/:id"
          render={(props) => {
            forAddEditBom();
            return <AddEditBomLibraryGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/bom-library-group/edit/:id/:groupId"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('bomAccess');
            return <AddEditBomLibraryGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/bom-type-group"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('bomAccess');
            return <BomTypeGroup {...props} />;
          }}
        />
        <Route
          exact
          path={Object.values(BOM_V2_ROUTES)}
          render={() => {
            if (!BOM_V2_ENABLED || role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('bomAccess');
            return (
              <Suspense fallback={<Loader />}>
                <BomV2Routes />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path={Object.values(PRODUCT_BOM_V2_ROUTES)}
          render={() => {
            if (!BOM_V2_ENABLED || !productsAccess) {
              redirectToDashboard();
              return false;
            }
            productAccessRedirect('bomAccess');
            return (
              <Suspense fallback={<Loader />}>
                <ProductBomV2Routes />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/bom"
          render={(props) => {
            if (!productsAccess) {
              redirectToDashboard();
              return false;
            }
            productAccessRedirect('bomAccess');
            return (
              <Suspense fallback={null}>
                <AblyWrapper>
                  <BomStateprovider>
                    <DevlopmentOrderWrapperLazy {...props} type="bom" redirectToDashboard={redirectToDashboard} />
                  </BomStateprovider>
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/care-user-instruction"
          render={(props) => {
            productAccessRedirect('care-user-instruction');
            return (
              <Suspense fallback={<Loader />}>
                <AblyWrapper>
                  <DevlopmentOrderWrapperLazy {...props} type="care-user-instruction" redirectToDashboard={redirectToDashboard} />
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/care-label/:careType"
          render={(props) => {
            productAccessRedirect('care-label');
            return <DevlopmentOrderWrapper {...props} type="care-label" redirectToDashboard={redirectToDashboard} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/design-details/List"
          render={(props) => {
            productAccessRedirect('designAccess');
            return (
              <Suspense fallback={<Loader />}>
                <AblyWrapper>
                  <DesignDetailWrapper {...props} redirectToDashboard={redirectToDashboard} />
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/testing/testing-requirements"
          render={(props) => {
            productAccessRedirect('testingAccess');
            redirectOnNoRight(TestingRight);
            return (
              <Suspense fallback={<Loader />}>
                <AblyWrapper>
                  <TestingWrapper {...props} redirectToDashboard={redirectToDashboard} />
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/design-details"
          render={(props) => {
            productAccessRedirect('designAccess');
            return <DesignDetailAnnotation {...props} redirectToDashboard={redirectToDashboard} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/samples"
          render={(props) => {
            productAccessRedirect('samplesAccess');
            return (
              <Suspense fallback={<Loader />}>
                <AblyWrapper>
                  <Samples {...props} redirectToDashboard={redirectToDashboard} />
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/sample/:sampleId"
          render={(props) => {
            productAccessRedirect('samplesAccess');
            return <SampleAnnotation {...props} redirectToDashboard={redirectToDashboard} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/supplier-sample/:sampleId"
          render={(props) => {
            productAccessRedirect('samplesAccess');
            return <SupplierImageAnnotation {...props} redirectToDashboard={redirectToDashboard} />;
          }}
        />
        <Route
          path={['/todo-list', '/todo-list/:childpath']}
          render={(props) => {
            // Wait for permissions to load before checking access rights
            if (spin && !isEmpty(moduleAccess) && !isEmpty(sectionAccess)) {
              const childpath = props?.match?.params?.childpath;

              // Only check access for specific childpaths, allow base /todo-list route
              if (childpath) {
                // Check modal access for the specific childpath
                if (!checkModalAccess(childpath)) {
                  redirectToDashboard();
                  return null;
                }

                // Check reports right and products access
                if (!(reportsRight && moduleAccess?.productsAccess)) {
                  redirectToDashboard();
                  return null;
                }

                // Check specific rights for certain childpaths
                if (
                  ['purchase-order', 'costing', 'suggestion', 'product-purchase-order-todo'].includes(childpath) &&
                  !checkRightWithKey(TabsToRightKeys[childpath])
                ) {
                  redirectToDashboard();
                  return null;
                }

                // Check testing rights
                if (['testing'].includes(childpath) && !TestingRight) {
                  redirectToDashboard();
                  return null;
                }
              } else if (!(reportsRight && moduleAccess?.productsAccess)) {
                // For base /todo-list route, only check basic reports access
                redirectToDashboard();
                return null;
              }
            }

            return <TodoList {...props} />;
          }}
          exact
        />
        <Route
          path="/development-order/:devOrderId/samples-details"
          render={() => {
            productAccessRedirect('samplesAccess');
            return (
              <AblyWrapper>
                <Route path="/development-order/:devOrderId/samples-details" component={SampleDetails} exact />
                <Route path="/development-order/:devOrderId/samples-details/:childpath" component={SampleDetails} />
              </AblyWrapper>
            );
          }}
        />
        <Route
          path="/range-plan/logs"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            forRangeplanUrlRedirect();
            return <RangePlanLogs {...props} />;
          }}
          exact
        />
        <Route
          exact
          path="/product/:devOrderId/:bomType"
          render={({ match }) => {
            const params = match?.params;
            const url = `/development-order/${params.devOrderId}/libraries/bom`;
            return (
              <BomStateprovider>
                <Redirect
                  to={{
                    pathname: url,
                    state: { ...params },
                  }}
                />
              </BomStateprovider>
            );
          }}
        />
        <Route
          exact
          path="/suppliers"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            forSupplierOverviewAccess();
            return <Supplier {...props} />;
          }}
        />
        <Route
          path={['/supplier/:supplierId/users', '/supplier/:supplierId/component-suppliers', '/supplier/:supplierId/supporting-docs']}
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            forSupplierOverviewAccess();
            return <SupplierTabLayout {...props} />;
          }}
        />
        <Route
          exact
          path="/settings/user-groups"
          render={(props) => {
            return <UserGroups {...props} />;
          }}
        />
        <Route
          exact
          path="/settings/users/:userId"
          render={(props) => {
            return <UserManagement {...props} />;
          }}
        />
        <Route
          exact
          path="/settings/user-library"
          render={(props) => {
            return <UsersLibrary {...props} />;
          }}
        />
        <Route
          exact
          path="/settings/account-details"
          render={(props) => {
            return <AccountDetails {...props} />;
          }}
        />
        <Route
          exact
          path="/settings/sso"
          render={(props) => {
            return <SsoSettings {...props} />;
          }}
        />
        <Route
          path="/settings/factories"
          render={(props) => {
            return <Factories {...props} />;
          }}
        />
        <Route
          exact
          path="/settings/supporting-docs/edit/:supplierId/template/:moduleLibId"
          render={(props) => {
            return (
              <SupplierTemplateProvider>
                <Suspense fallback={<Loader />}>
                  <SupplierTemplateAddEdit {...props} />
                </Suspense>
              </SupplierTemplateProvider>
            );
          }}
        />
        <Route
          exact
          path="/settings/supporting-docs/:supplierId"
          render={(props) => {
            if (role !== 'Supplier') {
              redirectToDashboard();
              return false;
            }
            return <SuppliersDocuments {...props} />;
          }}
        />
        <Route exact path="/utility" component={Utility} />
        <Route exact path="/master-design" component={MasterDesign} />
        <Route exact path="/bombiix-icons" component={BombiixIcons} />
        <Route exact path="/bombiix-icons-tsx" component={BombiixIconsTsx} />
        <Route
          exact
          path={['/supplier-suggestion/add', '/supplier-suggestion/edit/:suggId/:activeSection']}
          render={(props) => {
            redirectOnNoRight(suggestionRight);
            if (role !== 'Supplier') {
              redirectToDashboard();
              return false;
            }
            return (
              <SuggestionProvider>
                <SupplierSuggestion {...props} />
              </SuggestionProvider>
            );
          }}
        />
        <Route
          exact
          path="/supplier-suggestion/detail/:id/:section"
          render={(props) => {
            redirectOnNoRight(suggestionRight);
            return (
              <SuggestionProvider>
                <SupplierSuggestionDetail {...props} />
              </SuggestionProvider>
            );
          }}
        />
        {/* <Route exact path="/supplier-suggestion/detail/:id/:section" component={SupplierSuggestionDetail} /> */}
        <Route exact path="/marker" component={Measurment} />
        <Route
          exact
          path="/development-order/:devOrderId/measurement/:type/:gradingGroupId/:code"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            productAccessRedirect('measurementAccess');
            return <Measurment {...props} redirectToDashboard={redirectToDashboard} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/measurement"
          render={(props) => {
            productAccessRedirect('measurementAccess');
            return (
              <Suspense fallback={null}>
                <AblyWrapper>
                  <DevlopmentOrderWrapperLazy {...props} type="measurement" redirectToDashboard={redirectToDashboard} />
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/supplier-suggestion"
          render={(props) => {
            if (role === 'Supplier' && supplierPermission === false) {
              redirectToDashboard();
              return false;
            }
            redirectOnNoRight(suggestionRight);
            return <SuggestionList {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/costing-template"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('costingTemplateAccess');
            redirectOnNoRight(productCostingRight);
            return (
              <Suspense fallback={<Loader />}>
                <CostingListTsx {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/costing-column/:id"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('costingTemplateAccess');
            redirectOnNoRight(productCostingRight);
            return (
              <Suspense fallback={<Loader />}>
                <CostingTemplateProviderTsx>
                  <CostingColumnsTsx {...props} />
                </CostingTemplateProviderTsx>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/product-costing"
          render={(props) => {
            redirectOnNoRight(productCostingRight);
            productAccessRedirect('costingAccess');
            return (
              <Suspense fallback={<Loader />}>
                <AblyWrapper>
                  <ProductCostingTsx {...props} />
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          path={['/range-plan', '/range-plan/:childpath']}
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            forRangeplanUrlRedirect();
            return <RangePlan {...props} />;
          }}
          exact
        />
        <Route
          exact
          path="/placeholder-management-list/:placeholderId"
          render={(props) => <Redirect to={`/placeholder-management-card/edit/${props.match.params.placeholderId}`} />}
        />
        <Route
          exact
          path="/placeholder-management-card/edit/:id"
          render={(props) => {
            forPlaceHolderManagementRedirect();
            redirectOnNoRight(placeholderRight);
            return (
              <PlaceholderManagementStateProvider>
                <AblyWrapper>
                  <AddEditCardPage {...props} />
                </AblyWrapper>
              </PlaceholderManagementStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/placeholder-management-card/add"
          render={(props) => {
            forPlaceHolderManagementRedirect();
            redirectOnNoRight(placeholderRight);
            return (
              <PlaceholderManagementStateProvider>
                <AddEditCardPage {...props} />
              </PlaceholderManagementStateProvider>
            );
          }}
        />

        <Route
          exact
          path="/placeholder-management"
          render={(props) => {
            forPlaceHolderManagementRedirect();
            redirectOnNoRight(placeholderRight);
            return (
              <AblyWrapper>
                <CardListPage {...props} />
              </AblyWrapper>
            );
          }}
        />

        <Route
          exact
          path="/planning/planning-actual"
          render={(props) => {
            forPlanningAccessRedirect('topDownAccess');
            redirectOnNoRight(planningTopsDownRight);
            return (
              <PlanningActualProvider>
                <PlanningActual {...props} />
              </PlanningActualProvider>
            );
          }}
        />
        <Route
          exact
          path="/planning/planning-bottomup/channel-setting"
          render={(props) => {
            forPlanningAccessRedirect('bottomUpAccess');
            redirectOnNoRight(planningBottomUpRight);
            return (
              <PlanningBottomUpProvider>
                <Channel {...props} />
              </PlanningBottomUpProvider>
            );
          }}
        />
        <Route
          exact
          path="/planning/planning-bottomup"
          render={(props) => {
            forPlanningAccessRedirect('bottomUpAccess');
            redirectOnNoRight(planningBottomUpRight);
            return (
              <PlanningBottomUpProvider>
                <PlanningBottomUp {...props} />
              </PlanningBottomUpProvider>
            );
          }}
        />
        <Route
          exact
          path="/operational-cp/create/:id"
          render={(props) => {
            forCriticalPathRedirect('operationalAccess');
            redirectOnNoRight(operationalCriticalPathRight);
            return isSupplierLoggedIn ? redirectToDashboard() : <AddEditOprationalCP {...props} />;
          }}
        />
        <Route
          exact
          path="/operational-cp/create"
          render={(props) => {
            forCriticalPathRedirect('operationalAccess');
            redirectOnNoRight(operationalCriticalPathRight);
            return isSupplierLoggedIn ? redirectToDashboard() : <AddEditOprationalCP {...props} />;
          }}
        />
        <Route
          exact
          path="/operational-cp/details/:ocpId"
          render={(props) => {
            redirectOnNoRight(operationalCriticalPathRight);
            forCriticalPathRedirect('operationalAccess');
            return isSupplierLoggedIn ? redirectToDashboard() : <DetailsOprationalCPPage {...props} />;
          }}
        />
        <Route
          exact
          path="/operational-cp"
          render={(props) => {
            redirectOnNoRight(operationalCriticalPathRight);
            forCriticalPathRedirect('operationalAccess');
            return isSupplierLoggedIn ? redirectToDashboard() : <OprationalCPIndex {...props} />;
          }}
        />
        <Route
          exact
          path="/product-cp"
          render={(props) => {
            forCriticalPathRedirect('productAccess');
            redirectOnNoRight(productCriticalPathRight);
            return <ProductCPIndex {...props} />;
          }}
        />
        <Route
          path="/product-cp/logs"
          render={(props) => {
            forCriticalPathRedirect('productAccess');
            redirectOnNoRight(productCriticalPathRight);
            return <ProductCPLogs {...props} />;
          }}
          exact
        />
        <Route
          exact
          path="/product-cp/create/:id"
          render={(props) => {
            forCriticalPathRedirect('productAccess');
            redirectOnNoRight(productCriticalPathRight);
            return <AddEditProductCP {...props} />;
          }}
        />
        <Route
          exact
          path="/product-cp/create"
          render={(props) => {
            forCriticalPathRedirect('productAccess');
            redirectOnNoRight(productCriticalPathRight);
            return <AddEditProductCP {...props} />;
          }}
        />
        <Route
          exact
          path="/product-cp/details/:pcpId"
          render={(props) => {
            forCriticalPathRedirect('productAccess');
            redirectOnNoRight(productCriticalPathRight);
            return (
              <CPDetailStateProvider>
                <DetailProductCP {...props} />
              </CPDetailStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/rangeplan/card-view"
          render={(props) => {
            return <RangePlanCardView {...props} />;
          }}
        />
        <Route
          exact
          path={['/rangeplan/add', '/rangeplan/edit/:rangeplanId', '/rangeplan/add/:rangeplanId']}
          render={(props) => {
            return <AddEditRangePlan {...props} />;
          }}
        />
        <Route
          exact
          path="/rangeplan/archived"
          render={(props) => {
            return <RangePlanCardView {...props} archived />;
          }}
        />
        <Route
          exact
          path={['/rangeplan/product-list/:rangeplanId', '/rangeplan/product-list/:rangeplanId/visual-view']}
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            forRangeplanUrlRedirect();
            redirectOnNoRight(rangePlanRight);
            return (
              <RangePlanProductListingProvider>
                <RangePlanProductList {...props} />
              </RangePlanProductListingProvider>
            );
          }}
        />
        <Route
          exact
          path="/rangeplan/product-list/section"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            redirectOnNoRight(rangePlanRight);
            forRangeplanUrlRedirect();
            return <RangePlanCustomSection {...props} />;
          }}
        />
        <Route
          path={['/range-plan', '/range-plan/:childpath']}
          render={(props) => {
            redirectOnNoRight(rangePlanRight);
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            forRangeplanUrlRedirect();
            return <RangePlan {...props} />;
          }}
          exact
        />
        <Route
          exact
          path="/development-order/:devOrderId/purchase-orders"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <PurchaseOrder {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/order-po-template/product-purchase-order/:poId"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <ProductPurchaseOrderRedirect {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/product-purchase-order"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <AblyWrapper>
                  <NewPurchaseOrder {...props} />
                </AblyWrapper>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/product-purchase-order/add"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <CreateEditPO {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/product-purchase-order/edit/:poId"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <AblyWrapper>
                <Suspense fallback={<Loader />}>
                  <CreateEditPO {...props} />
                </Suspense>
              </AblyWrapper>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/product-purchase-order/:POId/documents"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <PurchaseOrderDocuments {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/product-purchase-order/:poId/logs"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return (
              <Suspense fallback={<Loader />}>
                <LogHistoryPage {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/order-po-template/:poCreatedId"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            const searchParams = new URLSearchParams(props.location?.search);
            const isPreview = searchParams.get('preview') === 'true';
            return (
              <PurchaseOrderStateProvider fromPreview={isPreview} isPublicPoPage={false}>
                <PurchaseOrderDetails {...props} />
              </PurchaseOrderStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/order-po-history/:poCreatedId"
          render={(props) => {
            redirectFunction();
            return <PurchaseOrderHistory {...props} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/order-po-log/:orderPoId"
          render={(props) => {
            redirectFunction();
            return <PurchaseOrderLog {...props} />;
          }}
        />
        <Route
          exact
          path="/rangeplan/product-list/columns/section/:sectionId"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            forRangeplanUrlRedirect();
            redirectOnNoRight(rangePlanRight);
            return (
              <CustomColumnContextProvider>
                <RangePlanColumnsCustomSection {...props} />
              </CustomColumnContextProvider>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/history"
          render={(props) => {
            redirectFunction();
            return <ProductHistory {...props} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/submit-download"
          render={(props) => {
            redirectFunction();
            return <SubmitDownlod {...props} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/submit-download-logs"
          render={(props) => {
            redirectFromSubmitLog();
            return <SubmitDownlodLog {...props} />;
          }}
        />
        <Route
          exact
          path="/multi-submit-download-logs"
          render={(props) => {
            return <MultiSubmitDownloadLogs {...props} />;
          }}
        />
        <Route
          exact
          path="/multi-download-logs"
          render={(props) => {
            return <MultiDownloadLogs {...props} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/download-logs"
          render={(props) => {
            redirectFromSubmitLog();
            return isSupplierLoggedIn ? redirectToDashboard() : <DownloadLog {...props} />;
          }}
        />
        <Route
          exact
          path="/submit-download-history"
          render={(props) => {
            redirectFunction();
            return <SubmitDownloadHistory {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/freight-duty"
          render={(props) => {
            redirectOnNoRight(frieghtRight);
            return (
              <Suspense fallback={<Loader />}>
                <FreightDutyTariffPage {...props} />
              </Suspense>
            );
          }}
        />
        <Route exact path="/libraries/freight" render={() => <Redirect to="/libraries/freight-duty?tab=freight" />} />
        <Route exact path="/libraries/duty" render={() => <Redirect to="/libraries/freight-duty?tab=duty" />} />
        <Route
          exact
          path="/libraries/asset-library"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            return (
              <Suspense fallback={<Loader />}>
                <AssetLibrary {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/pim-v2/templates"
          render={(props) => {
            redirectOnNoRight(PIMRight);
            forPIMAccess();
            return (
              <AblyWrapper>
                <PIMTemplatesPage {...props} />
              </AblyWrapper>
            );
          }}
        />
        <Route
          exact
          path="/pim-v2/product-table/:channelSetupId"
          render={(props) => {
            redirectOnNoRight(PIMRight);
            forPIMAccess();
            const { channelSetupId } = props.match.params;
            const state = props.location?.state || {};
            const qs = new URLSearchParams(props.location.search);
            const channelName = state.channelName || qs.get('channelName') || '';
            const setupName = state.setupName || channelName;
            return (
              <AblyWrapper>
                <PIMProductTablePage
                  key={channelSetupId}
                  channelSetupId={channelSetupId}
                  channelName={channelName}
                  setupName={setupName}
                  onBack={() => props.history.push('/pim-v2/templates')}
                />
              </AblyWrapper>
            );
          }}
        />
        <Route
          exact
          path="/pim-v2/downloads"
          render={(props) => {
            redirectOnNoRight(PIMRight);
            forPIMAccess();
            return <PIMDownloadLogPage {...props} />;
          }}
        />
        <Route
          exact
          path="/pim-v2/history"
          render={() => {
            redirectOnNoRight(PIMRight);
            forPIMAccess();
            return <PIMHistoryPage />;
          }}
        />
        <Route
          exact
          path="/pim-v2/products/:rowId"
          render={(props) => {
            redirectOnNoRight(PIMRight);
            forPIMAccess();
            return <PIMProductDetailPage {...props} />;
          }}
        />
        <Route
          exact
          path="/pim-v2/card-detail/:rowId"
          render={(props) => {
            redirectOnNoRight(PIMRight);
            forPIMAccess();
            return <PIMCardDetailPage {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/care/:careType"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('careAccess');
            return (
              <CareLabelProvider>
                <CareLabel {...props} />
              </CareLabelProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/care-group"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('careAccess');
            return (
              <CareLabelProvider>
                <CareLabelGroup {...props} />
              </CareLabelProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/care-group/edit/:groupId"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            return <CareLabelGroupAddEdit {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/care-group/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            return <CareLabelGroupAddEdit {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/care-user-instruction/:_id"
          render={(props) => {
            if (role === 'Supplier') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('careAccess');
            return (
              <CareUserContextProvider>
                <TabDetailsLandingPage {...props} />
              </CareUserContextProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/care-user-instruction"
          render={(props) => {
            if (role === 'Supplier' || role === 'supplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('careAccess');
            return (
              <Suspense fallback={<Loader />}>
                <CareUserContextProvider>
                  <UserInstructionType {...props} />
                </CareUserContextProvider>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/care-user-group-instruction/edit/:groupId"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('careAccess');
            return (
              <CareUserContextProvider>
                <AddEditCareUserGroup {...props} />
              </CareUserContextProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/care-user-group-instruction/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'supplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('careAccess');
            return (
              <CareUserContextProvider>
                <AddEditCareUserGroup {...props} />
              </CareUserContextProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/care-user-group-instruction"
          render={(props) => {
            if (role === 'Supplier' || role === 'supplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('careAccess');
            return (
              <CareUserContextProvider>
                <CareUserGroupListing {...props} />
              </CareUserContextProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/custom-module/library"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('customModuleAccess');
            redirectOnNoRight(customModuleRight);
            return (
              <Suspense fallback={<Loader />}>
                <CustomModuleStateProvider>
                  <CustomModuleList {...props} />
                </CustomModuleStateProvider>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/custom-module/library/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            checkUserAccessPermissionRoutes(CustomAddEditAccess);
            libraryAccessRedirect('customModuleAccess');
            redirectOnNoRight(customModuleRight);
            return (
              <CustomModuleStateProvider>
                <CustomModuleAddEdit {...props} />
              </CustomModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/custom-module/library/edit/:moduleLibId"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('customModuleAccess');
            redirectOnNoRight(customModuleRight);
            checkUserAccessPermissionRoutes(CustomAddEditAccess);
            return (
              <CustomModuleStateProvider>
                <CustomModuleAddEdit {...props} />
              </CustomModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/custom-module/group"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('customModuleAccess');
            redirectOnNoRight(customModuleRight);
            return <CustomModuleGroupList {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/custom-module/group/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('customModuleAccess');
            redirectOnNoRight(customModuleRight);
            checkUserAccessPermissionRoutes(CustomAddEditAccess);
            return <CustomModuleGroupAddEdit {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/custom-module/group/edit/:moduleGrpId"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('customModuleAccess');
            redirectOnNoRight(customModuleRight);
            checkUserAccessPermissionRoutes(CustomAddEditAccess);
            return <CustomModuleGroupAddEdit {...props} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/custom-module/:customLibId"
          render={(props) => {
            redirectOnNoRight(customModuleRight);

            return (
              <Suspense fallback={<Loader />}>
                <CustomModuleProductStateProvider>
                  <CustomModuleProduct {...props} redirectToDashboard={redirectToDashboard} />
                </CustomModuleProductStateProvider>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/spec-template"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }

            libraryAccessRedirect('specAccess');
            if (role === 'User') {
              forSpecAccess();
            }

            return (
              <Suspense fallback={<Loader />}>
                <SpecContextProvider>
                  <SpecTemplateList {...props} />
                </SpecContextProvider>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/spec-template/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('specAccess');
            if (role === 'User') {
              forSpecAccess();
            }
            checkUserAccessPermissionRoutes(SpecAddEditAccess);

            return <SpecTemplateAddEdit {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/spec-template/edit/:specTemplateId"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            libraryAccessRedirect('specAccess');
            if (role === 'User') {
              forSpecAccess();
            }
            checkUserAccessPermissionRoutes(SpecAddEditAccess);
            return <SpecTemplateAddEdit {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/pom-group/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            pomGradingAccess();
            checkUserAccessPermissionRoutes(pomAddEditAccess);
            return (
              <PomGroupProvider>
                <PomGroup {...props} />;
              </PomGroupProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/pom-group/edit/:id"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            pomGradingAccess();
            checkUserAccessPermissionRoutes(pomAddEditAccess);
            return (
              <PomGroupProvider>
                <PomGroup {...props} />;
              </PomGroupProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/pom-groups"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            pomGradingAccess();
            return (
              <PomGroupContextProvider>
                <PomList {...props} />;
              </PomGroupContextProvider>
            );
          }}
        />
        {/* BM-9211: the canonical path now serves the rewrite. Ten places across PIM, MyTodo,
            Multi Submit and the Range Plan cards deep-link here — and MyTodo uses it as the
            fallback for any unmapped location — so the module moved onto this path rather than
            the path moving to the module. No wrapper: the page brings its own provider and reads
            the dev order id from useParams. */}
        <Route
          exact
          path="/development-order/:devOrderId/product-identifier"
          render={(props) => {
            productIdentifierAccessRedirect(props.match.params.devOrderId);
            return (
              <Suspense fallback={<Loader />}>
                <ProductIdentifierTSX />
              </Suspense>
            );
          }}
        />
        {/* The transitional path kept as a redirect: it was bookmarked throughout BM-9580's
            development. A follow-up ticket drops it. */}
        <Redirect exact from="/development-order/:devOrderId/product-identifier-tsx" to="/development-order/:devOrderId/product-identifier" />

        <Route
          exact
          path="/supplier/:supplierId/document/:documentId/files"
          render={(props) => {
            checkUserAccessPermissionRoutes(supplierAddEditAccess);
            return (
              <SupplierTemplateProvider>
                <Suspense fallback={<Loader />}>
                  <SupplierTemplateAddEdit {...props} />
                </Suspense>
              </SupplierTemplateProvider>
            );
          }}
        />

        <Route
          exact
          path="/supplier/:supplierId/templates/edit/:moduleLibId"
          render={(props) => {
            checkUserAccessPermissionRoutes(supplierAddEditAccess);
            return (
              <SupplierTemplateProvider>
                <Suspense fallback={<Loader />}>
                  <SupplierTemplateAddEdit {...props} />
                </Suspense>
              </SupplierTemplateProvider>
            );
          }}
        />

        <Route
          exact
          path="/supplier/templates/edit/:moduleLibId"
          render={(props) => {
            checkUserAccessPermissionRoutes(supplierAddEditAccess);
            return (
              <SupplierTemplateProvider>
                <Suspense fallback={<Loader />}>
                  <SupplierTemplateAddEdit {...props} />
                </Suspense>
              </SupplierTemplateProvider>
            );
          }}
        />

        <Route
          exact
          path="/supplier/templates/add"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }
            checkUserAccessPermissionRoutes(supplierAddEditAccess);
            return (
              <SupplierTemplateProvider>
                <Suspense fallback={<Loader />}>
                  <SupplierTemplateAddEdit {...props} />
                </Suspense>
              </SupplierTemplateProvider>
            );
          }}
        />
        <Route
          exact
          path="/supplier/templates"
          render={(props) => {
            if (role === 'Supplier' || role === 'SupplierUser') {
              redirectToDashboard();
              return false;
            }

            return (
              <SupplierTemplateProvider>
                <Suspense fallback={<Loader />}>
                  <SupplierTemplate {...props} />
                </Suspense>
              </SupplierTemplateProvider>
            );
          }}
        />

        <Route
          exact
          path="/development-order/:devOrderId/digital-assets-management"
          render={(props) => {
            productAccessRedirect('DAMAccess');
            return (
              <Suspense fallback={<Loader />}>
                <DamProductFileModuleStateProvider>
                  <DamProductLazy {...props} />
                </DamProductFileModuleStateProvider>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/digital-assets-management/folder"
          render={(props) => {
            productAccessRedirect('DAMAccess');
            return (
              <DamProductFolderModuleStateProvider>
                <DamFolder {...props} />
              </DamProductFolderModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/digital-assets-management/folder"
          render={(props) => {
            forDAMAccess();
            redirectOnNoRight(DAMRight);
            return (
              <DamFolderModuleStateProvider>
                <DamFolderGroup {...props} />
              </DamFolderModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/bom-library-group/add/:id"
          render={(props) => {
            forAddEditBom();
            return <AddEditBomLibraryGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/digital-assets-management/folder/add"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            checkUserAccessPermissionRoutes(DamAddEditAccess);
            return <AddEditDamFolderGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/digital-assets-management/folder/edit/:id"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            checkUserAccessPermissionRoutes(DamAddEditAccess);
            return <AddEditDamFolderGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/digital-assets-management/folder/duplicate/:id"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            checkUserAccessPermissionRoutes(DamAddEditAccess);
            return <AddEditDamFolderGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/digital-assets-management"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            return (
              <DAMModuleStateProvider>
                <DAM {...props} />
              </DAMModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/digital-assets-management/add"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            checkUserAccessPermissionRoutes(DamAddEditAccess);
            return (
              <DAMAddEditModuleStateProvider>
                <AddEditDAM {...props} />
              </DAMAddEditModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/digital-assets-management/edit/:damId"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            checkUserAccessPermissionRoutes(DamAddEditAccess);
            return (
              <DAMAddEditModuleStateProvider>
                <AddEditDAM {...props} />
              </DAMAddEditModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/digital-assets-management/duplicate/:damId"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            checkUserAccessPermissionRoutes(DamAddEditAccess);
            return (
              <DAMAddEditModuleStateProvider>
                <AddEditDAM {...props} />
              </DAMAddEditModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/digital-assets-management/history"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            return <DamHistory {...props} />;
          }}
        />
        <Route
          exact
          path="/digital-assets-management/:devOrderId/add"
          render={(props) => {
            if (isSupplierLoggedIn) {
              redirectToDashboard();
            }
            checkUserAccessPermissionRoutes(damProAddEditAccess);
            return (
              <DAMAddEditModuleStateProvider>
                <AddEditDAM {...props} />
              </DAMAddEditModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/digital-assets-management/:devOrderId/edit/:damId"
          render={(props) => {
            checkUserAccessPermissionRoutes(damProAddEditAccess);
            return (
              <DAMAddEditModuleStateProvider>
                <AddEditDAM {...props} />
              </DAMAddEditModuleStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/digital-assets-management/folder/:devOrderId/edit/:id"
          render={(props) => {
            redirectOnNoRight(DAMRight);
            forDAMAccess();
            checkUserAccessPermissionRoutes(damProAddEditAccess);
            return <AddEditDamFolderGroup {...props} />;
          }}
        />
        <Route
          exact
          path="/libraries/retail-identifier/add"
          render={(props) => {
            libraryModuleAccessRedirect('retailIdentifierAccess');
            checkUserAccessPermissionRoutes(retailIdentifierAddEditAccess);
            return (
              <Suspense fallback={<Loader />}>
                <RetailIdentifierAddEdit {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/retail-identifier/batch/:batchId"
          render={(props) => {
            libraryModuleAccessRedirect('retailIdentifierAccess');
            return (
              <Suspense fallback={<Loader />}>
                <RetailIdentifierAddEdit {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/retail-identifier"
          render={(props) => {
            libraryModuleAccessRedirect('retailIdentifierAccess');
            return (
              <Suspense fallback={<Loader />}>
                <RetailIdentifierList {...props} />
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/dpp"
          render={(props) => {
            return (
              <Suspense fallback={<Loader />}>
                <DPPStateProvider>
                  <DPPList {...props} />
                </DPPStateProvider>
              </Suspense>
            );
          }}
        />
        <Route
          exact
          path="/libraries/dpp/add"
          render={(props) => {
            redirectOnNoRight(DPPRight);
            return (
              <DPPStateProvider>
                <DPPAddEdit {...props} />
              </DPPStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/libraries/dpp/edit/:dppLibId"
          render={(props) => {
            redirectOnNoRight(DPPRight);
            checkUserAccessPermissionRoutes(dppAddEditAccess);
            return (
              <DPPStateProvider>
                <DPPAddEdit {...props} />
              </DPPStateProvider>
            );
          }}
        />
        <Route
          exact
          path="/supplier-to-do-edit/:toDoId/:devOrderId"
          render={(props) => {
            return <EditSupplierToDo {...props} />;
          }}
        />
        <Route
          exact
          path="/development-order/:devOrderId/dpp-module/:dppLibId"
          render={(props) => {
            redirectOnNoRight(DPPRight);
            productAccessRedirect('productAccess');
            forDPPAccess();
            return (
              <Suspense fallback={<Loader />}>
                <DPPProductModuleStateProvider>
                  <DPPProduct {...props} redirectToDashboard={redirectToDashboard} />
                </DPPProductModuleStateProvider>
              </Suspense>
            );
          }}
        />

        <Route
          exact
          path="/documents"
          render={(props) => {
            forManualAccess();
            redirectOnNoRight(manualDocsRight);
            return (
              <ManualDocStateProvider>
                <Document {...props} redirectToDashboard={redirectToDashboard} />
              </ManualDocStateProvider>
            );
          }}
        />
        <Route
          exact
          path={[
            '/development-order/:devOrderId/product-costing-detail/add',
            '/development-order/:devOrderId/product-costing-detail/:productid',
            '/product-costing-supplier',
          ]}
          render={(props) => {
            return (
              <ProductCostingTsxStateProvider>
                <AblyWrapper>
                  <ProductCostingTsxDetailPage {...props} />
                </AblyWrapper>
              </ProductCostingTsxStateProvider>
            );
          }}
        />

        <Route
          exact
          path="/todo-list/product-purchase-order-todo/create"
          render={(props) => {
            productAccessRedirect('purchaseOrderAccess');
            redirectOnNoRight(purchaseOrderRight);
            return <CreatePO {...props} />;
          }}
        />

        {/**
         * Catch-all for an authenticated visitor whose path matches no route above,
         * which includes the bare origin a returning user opens from a bookmark.
         * Reports is the same destination a fresh login lands on, and the /todo-list
         * route guard re-routes via redirectToDashboard when the user lacks the
         * reports or products right, so rights still decide the final screen.
         */}
        <Route render={() => <Redirect to="/todo-list/my-todo" />} />
      </Switch>
      <ProgressbarUploader />
    </>
  );
}

export function PublicRoutes() {
  /**
   * Sends a visitor who still holds a session away from the public auth screens.
   * Targets the same screen as a completed login so that reopening a bookmarked
   * /login and signing in afresh both finish in the same place.
   */
  const redirectToDashboard = () => {
    window.location.assign('/todo-list/my-todo');
  };
  const checkIfUserLoggedIn = () => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if ((user?.mfaEnabled && user?.mfaVerified) || user?.masterPasswordMatched) {
      redirectToDashboard();
      return true;
    }
    return false;
  };
  return (
    <Switch>
      <Route
        exact
        path="/development-order/:devOrderId/submit-download-log-permission"
        render={(props) => {
          return <SubmitDownloadLogPublic {...props} />;
        }}
      />
      <Route
        exact
        path="/all-submit-download-log-permission"
        render={(props) => {
          return <SubmitDownloadLogPublic {...props} />;
        }}
      />
      <Route
        exact
        path="/development-order/:devOrderId/submit-download-logs"
        render={(props) => {
          return <SubmitDownlodLog {...props} />;
        }}
      />
      <Route
        exact
        path="/multi-submit-download-logs"
        render={(props) => {
          return <MultiSubmitDownloadLogs {...props} />;
        }}
      />
      <Route
        exact
        path="/multi-download-logs"
        render={(props) => {
          return <MultiDownloadLogs {...props} />;
        }}
      />
      <Route
        exact
        path="/supplier-component-order"
        render={(props) => {
          return (
            <POrderDetailStateProvider>
              <PurchaseOrderDetail {...props} />
            </POrderDetailStateProvider>
          );
        }}
      />
      <Route
        exact
        path="/product-purchase-order"
        render={(props) => {
          return (
            <PurchaseOrderStateProvider isPublicPoPage>
              <PreviewModal onOpen={false} toggle={false} isPublicPoPage {...props} />
            </PurchaseOrderStateProvider>
          );
        }}
      />
      {/**
       * Non-integrated supplier costing link. Registered here as well as in
       * PrivateRoutes because the link carries no session, so an anonymous
       * visitor is served PublicRoutes and would otherwise hit the catch-all
       * redirect to /login. AblyWrapper is intentionally omitted: it blocks on
       * an authenticated Ably client, and the chat it powers is gated on the
       * :productid route param, which this route does not have.
       */}
      <Route
        exact
        path="/product-costing-supplier"
        render={(props) => {
          return (
            <ProductCostingTsxStateProvider>
              <ProductCostingTsxDetailPage {...props} />
            </ProductCostingTsxStateProvider>
          );
        }}
      />
      <Route
        exact
        path="/login/sso/complete"
        render={(props) => {
          return <SsoComplete {...props} />;
        }}
      />
      <Route
        exact
        path="/login"
        render={(props) => {
          const redirecting = checkIfUserLoggedIn();
          return <Login {...props} redirecting={redirecting} />;
        }}
      />
      <Route
        exact
        path="/set-new-password"
        render={(props) => {
          checkIfUserLoggedIn();
          return <SetNewPassword {...props} />;
        }}
      />
      <Route
        exact
        path="/change-password"
        render={(props) => {
          return <ResetPassword {...props} />;
        }}
      />
      <Route
        exact
        path="/forgot-password"
        render={(props) => {
          return <ForgotPW {...props} />;
        }}
      />
      <Route exact path="/set-security-question" render={({ location }) => <Redirect to={`/setup2fa${location.search}`} />} />
      <Route
        exact
        path="/suppliers-register"
        render={(props) => {
          return <SupplierSignup {...props} />;
        }}
      />

      <Route
        exact
        path="/answer-security-question"
        render={(props) => {
          checkIfUserLoggedIn();
          return <AnswerSecurityQuestions {...props} />;
        }}
      />

      <Route
        exact
        path="/setup2fa"
        render={(props) => {
          return <Setup2FA {...props} />;
        }}
      />

      <Route
        exact
        path="/verify-code"
        render={(props) => {
          return <VerificationCode {...props} />;
        }}
      />
      <Route
        exact
        path="/supplier-account-details"
        render={(props) => {
          return <NonSupplierFactory {...props} />;
        }}
      />
      <Route
        path="/user-confirm"
        render={(props) => {
          return <AccountConfirmation {...props} />;
        }}
      />
      <Route render={() => <Redirect to="/login" />} />
    </Switch>
  );
}
